// Erik's Curiosa pure helper. No React, no Three.js.
//
// ── Codex (Erik's Curiosa, Artifact) ──
//   "Rip Erik's Curiosa to pieces → Draw a card from your collection."
//
// "Rip to pieces" banishes the artifact as the activation; the player
// then takes any card from their in-match Collection pile into hand.
// The collection pick reuses the existing pile-search dialog (the same
// flow SEARCH_DECK + Imposter's Mask use), so there is no bespoke
// picker. The op just wires the banish-self cost to that dialog.
//
// Host adapter contract:
//   banishCard(card): void. Rip the artifact to pieces
//   openCollectionSearch(controller, sourceName): void
// Opens the controller's Collection pile in the search dialog;
//       the picked card goes to hand (no filter, no shuffle).
//   logAction(key, values?): void

import { msg } from '../../../../logMessage';

/**
 * Resolve Erik's Curiosa's "rip to pieces → draw from collection".
 *
 * @param {object} artifact   the Erik's Curiosa instance
 * @param {string} controller 'p1' | 'p2'
 * @param {object} host
 */
export function applyDrawFromCollection(artifact, controller, host) {
  host.logAction('{card} is ripped to pieces', { card: artifact.name || msg("Erik's Curiosa") });
  host.banishCard(artifact);
  host.openCollectionSearch(controller, artifact.name || "Erik's Curiosa");
}
